export default function() {
  let id = 0;
  return () => id++;
}
